import createDocumentSlice from "./createDocumentSlice";
import { config } from "../../utils/apiUrl";

/*
|--------------------------------------------------------------------------
| SALE ORDER MODULE
|--------------------------------------------------------------------------
*/

const saleOrderModule =
  createDocumentSlice({
    sliceName:
      "saleOrder",

    stateKey:
      "saleOrder",

    documentName:
      "Sale Order",

    documentType:
      "SALE_ORDER",

    documentKey:
      "saleOrder",

    documentKeys: [
      "sourceSaleOrder",
    ],

    listKey:
      "saleOrders",

    urls: {
      list:
        config.getSaleOrders,

      summary:
        config.getSaleOrderSummary,

      createData:
        config.getSaleOrderCreateData,

      dropdowns:
        config.getSaleOrderDropdowns,

      getById:
        config.getSaleOrderById,

      create:
        config.createSaleOrder,

      update:
        config.updateSaleOrder,

      confirm:
        config.confirmSaleOrder,

      cancel:
        config.cancelSaleOrder,

      duplicate:
        config.duplicateSaleOrder,

      convert:
        config.convertSaleOrder,

      delete:
        config.deleteSaleOrder,

      history:
        config.getSaleOrderHistory,
    },

    initialFilters: {
      paymentStatus:
        "",

      fulfillmentStatus:
        "",

      conversionStatus:
        "",
    },

    initialSummary: {
      unpaidCount:
        0,

      partiallyPaidCount:
        0,

      paidCount:
        0,

      notFulfilledCount:
        0,

      partiallyFulfilledCount:
        0,

      fulfilledCount:
        0,
    },

    initialDropdowns: {
      documentStatuses:
        [],

      paymentStatuses:
        [],

      fulfillmentStatuses:
        [],

      conversionStatuses:
        [],

      conversionTargets:
        [],

      salesChannels:
        [],

      priceModes:
        [],

      discountTypes:
        [],
    },

    supportsConfirm:
      true,

    supportsCancel:
      true,

    supportsDuplicate:
      true,

    supportsConvert:
      true,

    supportsDelete:
      true,

    supportsHistory:
      true,
  });

/*
|--------------------------------------------------------------------------
| REDUCER
|--------------------------------------------------------------------------
*/

export default
  saleOrderModule.reducer;

/*
|--------------------------------------------------------------------------
| ACTIONS
|--------------------------------------------------------------------------
*/

export const {
  setFilters:
    setSaleOrderFilters,

  setFilter:
    setSaleOrderFilter,

  setPage:
    setSaleOrderPage,

  setLimit:
    setSaleOrderLimit,

  resetFilters:
    resetSaleOrderFilters,

  setSelectedDocument:
    setSelectedSaleOrder,

  clearSelectedDocument:
    clearSelectedSaleOrder,

  clearHistory:
    clearSaleOrderHistory,

  clearErrors:
    clearSaleOrderErrors,

  clearOperation:
    clearSaleOrderOperation,

  clearLastCreatedDocument:
    clearLastCreatedSaleOrder,

  clearLastDuplicatedDocument:
    clearLastDuplicatedSaleOrder,

  clearLastConvertedDocument:
    clearLastConvertedSaleOrderDocument,

  resetState:
    resetSaleOrderState,
} =
  saleOrderModule.actions;

/*
|--------------------------------------------------------------------------
| THUNKS
|--------------------------------------------------------------------------
*/

export const {
  fetchDocuments:
    fetchSaleOrders,

  fetchSummary:
    fetchSaleOrderSummary,

  fetchCreateData:
    fetchSaleOrderCreateData,

  fetchDropdowns:
    fetchSaleOrderDropdowns,

  fetchDocumentById:
    fetchSaleOrderById,

  createDocument:
    createSaleOrder,

  updateDocument:
    updateSaleOrder,

  confirmDocument:
    confirmSaleOrder,

  cancelDocument:
    cancelSaleOrder,

  duplicateDocument:
    duplicateSaleOrder,

  convertDocument:
    convertSaleOrder,

  deleteDocument:
    deleteSaleOrder,

  fetchDocumentHistory:
    fetchSaleOrderHistory,
} =
  saleOrderModule.thunks;

/*
|--------------------------------------------------------------------------
| SELECTORS
|--------------------------------------------------------------------------
*/

export const {
  selectModule:
    saleOrderSelector,

  selectDocuments:
    saleOrderListSelector,

  selectSelectedDocument:
    selectedSaleOrderSelector,

  selectSummary:
    saleOrderSummarySelector,

  selectFilters:
    saleOrderFiltersSelector,

  selectPagination:
    saleOrderPaginationSelector,

  selectCreateData:
    saleOrderCreateDataSelector,

  selectDropdowns:
    saleOrderDropdownsSelector,

  selectHistory:
    saleOrderHistorySelector,

  selectLoading:
    saleOrderLoadingSelector,

  selectOperation:
    saleOrderOperationSelector,
} =
  saleOrderModule.selectors;